var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "breadcrumbs-container" },
    [
      _c(
        "router-link",
        { staticClass: "go-dashboard", attrs: { to: _setup.dashboardRoute } },
        [_c("span", { class: [_setup.homeIcon, "lf-icon__md"] })]
      ),
      _c("span", { staticClass: "separator" }, [_vm._v(">")]),
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            class: ["breadcrumb", { "to-lower-case": item.lowerCase }],
          },
          [
            item.url
              ? _c(
                  "router-link",
                  {
                    staticClass: "breadcrumb-link",
                    attrs: { to: item.url },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.onClickItem.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_setup.replaceDash(item.text)) + " ")]
                )
              : _c("span", { staticClass: "breadcrumb-text" }, [
                  _vm._v(" " + _vm._s(_setup.replaceDash(item.text)) + " "),
                ]),
            index + 1 < _setup.numberOfItems
              ? _c("span", { staticClass: "separator" }, [_vm._v(">")])
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }